<template>
  <!-- <div class="bg" :style="'backgroundImage:url(' + playDetai.coverImgUrl + ')'"></div> -->
  <div class="content">
    <div
      class="bg"
      :style="'backgroundImage:url(' + playDetai.coverImgUrl + ')'"
    ></div>
    <div class="fl">
      <img :src="playDetai.coverImgUrl" />
      <b>歌单</b>
      <span
        ><i class="fa fa-headphones"></i
        >{{ translatePlayCount(playDetai.playCount) }}</span
      >
    </div>
    <dl class="fr">
      <dt>
        <h1>{{ playDetai.name }}</h1>
        <div class="pic">
          <img class="author" :src="playDetai.creator.avatarUrl" alt="" />
        </div>
        <div class="tit">
          <span class="firstname">{{ playDetai.creator.nickname }}</span>
          <br />
          <span class="create">{{ timeCon(playDetai.createTime) }}创建</span>
        </div>
      </dt>
      <dd>
        <h5>
          标签：
          <span
            class="tag"
            v-for="(item, index) in playDetai.tags"
            :key="index"
            >{{ item }}</span
          >
        </h5>
        <h5 class="desc">介绍：{{ playDetai.description }}</h5>
      </dd>
    </dl>
  </div>
</template>

<script>
// import SongListCard from "@/components/SongListCard.vue";

export default {
  props: ["playDetai"],
  methods: {
    // 时间转换
    timeCon(n) {
      var now = new Date(n);
      var year = now.getFullYear(n);
      var month = now.getMonth(n) + 1;
      var day = now.getDate(n);
      return year + "-" + month + "-" + day;
    },

    translatePlayCount(n) {
      if (n > 99999999) {
        return (n / 100000000).toFixed(1) + "亿";
      }
      if (n > 9999) {
        // toFixed指定小数点保留位数
        return (n / 10000).toFixed(1) + "万";
      }
    }
  }
};
</script>

<style lang="less">
.content {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 10px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: -1;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    background-position: center center;
    background-size: cover;
    filter: blur(20px);
    height: 100%;
    z-index: -1;
    &::after {
      content: "";
      display: block;
      background: rgba(0, 0, 0, 0.25);
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  .fl {
    width: 40%;
    float: left;
    padding: 30px 0 0 15px;
    position: relative;
    // z-index: 5;
    text-align: center;

    img {
      border-radius: 2px;
      width: 100%;
    }
    b {
      color: #fff;
      display: inline-block;
      position: absolute;
      top: 42px;
      left: 15px;
      background: rgba(217, 48, 48, 0.8);
      line-height: 20px;
      padding: 0 8px;
      font-size: 12px;
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
    }
    span {
      display: inline-block;
      position: absolute;
      top: 30px;
      right: 0;
      font-size: 12px;
      color: #fcfcfc;
      background: rgba(0, 0, 0, 0.3);
      padding: 2px 5px;
      i {
        display: inline-block;
        padding-right: 5px;
        font-style: normal;
      }
    }
  }
  .fr {
    width: 60%;
    float: left;
    padding: 0 10px;
    font-size: 12px;
    line-height: 20px;
    position: relative;
    // z-index: 5;
    dt {
      overflow: hidden;
      h1 {
        font-size: 16px;
        color: #fefefe;
        line-height: 30px;
      }
      .pic {
        float: left;
        .author {
          border-radius: 50%;
          border: 1px solid #ccc;
          width: 35px;
          height: 35px;
        }
      }
      .tit {
        float: left;
        margin-left: 10px;
        .firstname {
          display: inline-block;
          padding-right: 5px;
          color: #2576c5;
        }
        .create {
          color: #999;
        }
      }
    }
    dd {
      h5 {
        margin: 5px 0;
        color: #fefefe;
        // color: #666;
        .tag {
          display: inline-block;
          padding: 0 10px;
          margin-right: 5px;
          color: #777;
          border: 1px solid #777;
          background: #fcfcfc;
          border-radius: 10px;
        }
      }
      .desc {
        height: 60px;
        overflow: scroll;
        color: #fefefe;
      }
    }
  }
}
</style>
